import Spinner from "../../../common/components/Loader/Spinner";

export const MediaLoadingCard = ({ className = "" }: { className?: string }) => {
  return (
    <div
      className={`${className} rounded-xl flex relative bg-white overflow-hidden shadow-md image-card`}
      data-testid="media-loading-card"
    >
      <div className="w-full h-full">
        <div className="p-2 flex items-center justify-center w-full h-32 sm:h-48">
          <div className="relative bg-gray-100 w-full h-full flex items-center justify-center rounded-xl overflow-hidden">
            <Spinner />
          </div>
        </div>
        <div className="block mt-1 mb-3 mx-4">
          <h3 className="text-sm">&nbsp;</h3>
          <span className="text-xs">&nbsp;</span>
        </div>
      </div>
    </div>
  );
};
